import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IPmProvider {
  Id: string
  ContessaId: number
  Name: string
  Address: string
  City: string
  State: string
  ZipCode: string
  NPI: string
  JVName: string
  ProviderTypeId: number
  CreatedDate: Date
  ModifiedDate: Date
  CreatedBy: string
  ModifiedBy: string
  CompositeName: string
  TaxIdNumber: string
  IsAnchor: boolean
}

@Injectable()
export class PmProviderODataService extends ODataService<IPmProvider> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'Providers'
  }
}
